var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictoLinkedin1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.436,
    height: 17.847,
    viewBox: "0 0 19.436 17.847",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_109",
    "data-name": "Trac\\xE9 109",
    d: "M133.332,196.724h-3.79V184.6h3.79Zm-1.992-13.641h-.027a2.1,2.1,0,0,1-2.259-2.1,2.308,2.308,0,1,1,2.287,2.1Zm17.149,13.641h-4.3V190.45c0-1.642-.671-2.763-2.15-2.763a2.172,2.172,0,0,0-2.051,1.486,2.814,2.814,0,0,0-.093.991v6.561h-4.256s.056-11.114,0-12.124H139.9v1.9c.253-.832,1.611-2.019,3.783-2.019,2.691,0,4.807,1.744,4.807,5.5Z",
    transform: "translate(-129.053 -178.877)",
    fill: "#273375"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoLinkedin1);
export default __webpack_public_path__ + "static/media/picto_linkedin_1.fc9ddb7214334a01eeec8963b210905a.svg";
export { ForwardRef as ReactComponent };